/**
 * SOLID Review
 * S — Strong. One rule: which zone the game screen's ad area shows.
 * O — Good. A new zone is one more branch here and one more value of `TClientAdZone`.
 * L — N/A — a function.
 * I — Strong. One export, reading three session fields.
 * D — Strong. The session schema's types only.
 */
import type { IStateClientSession } from '../ports/schemas/ClientSession';
import type { TClientAdZone } from '../ports/schemas/AdsMoves';

/**
 * Which zone the game screen shows (frontend strict-ports plan, FE4d, 2026-10-04) — AppRoot's ternary,
 * moved. A premium player has no ad area. Without advertising consent (denied, or not yet resolved) the
 * same-sized area holds a cookie-free placeholder, so nothing shifts and no ad or cookie is served. With
 * it: AdSense's slot, or Monetag's banner.
 *
 * READ WHEN THE VIEW IS BUILT, NOT KEPT (deviation from the plan's "settleSession recomputes", flagged in
 * §28.201): a table decision's reset unseats the player without a session step, and a kept zone would
 * then be stale. A pure rule over the session, like `isAdvertisingAllowed` beside the consent schema.
 */
export function adZoneOf(session: Pick<IStateClientSession, 'player' | 'consent' | 'ads'>): TClientAdZone {
  if (session.player !== null && session.player.matchCredits > 0) return 'none';
  if (!session.consent.advertisingAllowed) return 'placeholder';
  return session.ads.provider === 'ADSENSE' ? 'adsense' : 'propeller';
}
